/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ICoreContext, IImageSettings, ITelemetry } from '@msdyn365-commerce/core';
import { ICartState, ICheckoutState } from '@msdyn365-commerce/global-state';
import { AsyncResult, ProductAvailableQuantity, ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import ProductCard, { ISmweSearchResultContainerParentProps } from '../../../components/product.component';
import { IElicitSubscriptionsResources } from '../elicit-subscriptions.props.autogenerated';

interface IProductSearchResultItems {
    products: ProductSearchResult[];
    context: ICoreContext;
    resources: IElicitSubscriptionsResources;
    telemetry: ITelemetry;
    imageSettings?: IImageSettings;
    moduleType: string;
    moduleId: string;
    parentProps: ISmweSearchResultContainerParentProps;
    checkoutState?: AsyncResult<ICheckoutState>;
    disableQuantitySlider?: boolean;
    maxAdditionLimit?: number;
    cart?: AsyncResult<ICartState>;
    productAvailability?: ProductAvailableQuantity[] | undefined;
}

export const ProductSearchResultItems: React.FC<IProductSearchResultItems> = ({
    products,
    context,
    imageSettings,
    resources,
    moduleType,
    moduleId,
    parentProps,
    checkoutState,
    disableQuantitySlider,
    maxAdditionLimit,
    cart,
    productAvailability
}) => {
    return (

        <ul className='list-unstyled' role='presentation'>
            {products.map((product: ProductSearchResult, index: number) => {
                const availibity = productAvailability?.find((item) => {
                    return item.ProductId === product.RecordId;
                });
                return (
                <li className='ms-product-search-result__item' key={index}>
                    <ProductCard
                        displayQuantitySlider={true}
                        cart={cart}
                        disableQuantitySlider={disableQuantitySlider}
                        maxAdditionLimit={maxAdditionLimit}
                        subscriptionBtnText={resources.elicitSubscriptions_buyboxSubscriptionBtnTxt}
                        checkoutState={checkoutState}
                        context={context}
                        imageSettings={imageSettings}
                        freePriceText={resources.priceFree}
                        originalPriceText={resources.originalPriceText}
                        currentPriceText={resources.currentPriceText}
                        ratingAriaLabel={resources.ratingAriaLabel}
                        id={moduleId}
                        typeName={moduleType}
                        data={{ product: product }}
                        parentProps={parentProps}
                        availability={availibity}
                        addToCartMessage={resources.addToBoxMessagePlp}
                    />
                </li>
                );
            })}
        </ul>
    );

};